module.exports = __webpack_public_path__ + "static/media/cynthia-del-rio.3a7ae9b9.jpg";